import React, { Fragment } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  CardMedia,
  Divider,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns"; // Use date-fns to format the date
import SEO from "../../components/ceo/CEO";

const ProjectDetails = () => {
  const location = useLocation();
  const project = location.state;
  const navigate = useNavigate();

  const formattedDate = format(new Date(project.date), "MMMM d, yyyy");

  return (
    <Fragment>
      <SEO
        title={project.title}
        description={project.description}
        url="https://shallafg.org/project/details/"
        image={project.image}
      />
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          paddingY: "80px", // Add top and bottom padding for better layout
          minHeight: "100vh", // Ensure it takes full height
          display: "flex",
          alignItems: "center", // Vertically center the content
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={8} alignItems="flex-start">
            {/* Project Image Section */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  borderRadius: "16px", // Rounded corners for modern look
                  overflow: "hidden", // Ensures image fits within border
                  boxShadow: "0 12px 40px rgba(0, 0, 0, 0.3)", // Shadow for image
                  transition: "transform 0.4s ease, box-shadow 0.4s ease",
                  "&:hover": {
                    transform: "scale(1.05)", // Hover zoom effect
                    boxShadow: "0 16px 50px rgba(0, 0, 0, 0.5)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={project.image}
                  alt={project.title}
                  sx={{
                    width: "100%",
                    height: "auto",
                  }}
                />
              </Box>
            </Grid>

            {/* Project Details Section */}
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    fontSize: "2.5rem",
                    color: "#FFFFFF",
                    marginBottom: "20px",
                    lineHeight: 1.2,
                    textShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {project.title}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "#D1D5DB",
                    fontSize: "1.15rem",
                    lineHeight: "1.8",
                    marginBottom: "24px",
                  }}
                >
                  {project.description}
                </Typography>

                <Divider
                  sx={{
                    backgroundColor: "#A9C9EA",
                    opacity: 0.6,
                    marginY: "24px",
                  }}
                />

                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "#A9C9EA",
                    fontWeight: 600,
                    marginBottom: "40px",
                    fontSize: "1rem",
                  }}
                >
                  Date Created: {formattedDate}
                </Typography>

                {/* Call to Action - Go Back Button */}
                <Button
                  variant="contained"
                  onClick={() => navigate("/project/")}
                  sx={{
                    backgroundColor: "#10a7e0",
                    color: "#FFFFFF",
                    padding: "12px 36px",
                    fontSize: "1rem",
                    borderRadius: "50px",
                    textTransform: "uppercase",
                    transition: "all 0.3s ease",
                    boxShadow: "0 8px 24px rgba(0, 123, 255, 0.3)",
                    "&:hover": {
                      backgroundColor: "#10a7e0",
                      boxShadow: "0 12px 36px rgba(0, 86, 179, 0.5)",
                      transform: "translateY(-3px)",
                    },
                  }}
                >
                  Go Back
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fragment>
  );
};

export default ProjectDetails;
